export default "__VITE_ASSET__AVeomAeV__"